/**
 * V2 source path: customer/midas/components/v2/lib/utils.ts
 * V1 source: scratch (shadcn-standard helper)
 * Strategy: scratch-with-reused-handlers
 * Verified no-MUI: yes
 * Phase: 0
 */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merges Tailwind class names with clsx-style conditional inputs and
 * resolves Tailwind utility conflicts via tailwind-merge. This is the
 * canonical shadcn `cn()` helper.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
